import './customer-message';
import './order-footer';
import './customer';
import './customer.address.map-polygons';
import './customer.address.door-dash-drive';
import './customer.address.uber-direct';
import './customer.details';
import './customer.gift-card';
import './customer.loyalty-club-form';
import './customer.rewards';
import './customer.verification';
import './customer.phone-number-modal';
import './locations.finder';
import './menu.categories';
import './menu.list';
import './menu.products';
import './onepager.footer';
import './order.available-rewards-indicator';
import './order.checkout-button';
import './order.confirmation';
import './order.datetime';
import './order.gifting-modal';
import './order.loyalty';
import './order.payment-redirect-loading-modal';
import './order.preconfirmation-warning';
import './order.product-suggestions';
import './order.reward';
import './order.taxes';
import './order.tip-modal';
import './order.total';
import './order.voucher';
import './order.curbside-pickup'
import './product-editor';
import './test-order-control';
import './side-effects';
import '@/common/view-data-attributes';
import './banner';
